import request from "@/utils/request";
import requestMajestic from "@/utils/requestToMajesticServer";
import requestToVivo from "@/utils/requestToVivo";
import v1VideoListProd from "@/utils/v1_video_list_production";
import v1VideoListStaging from "@/utils/v1_video_list_staging";

export async function loadFromSlugMajestic(context, slug) {
  return loadSlugMajestic(context, slug);
}

export async function loadFromPathMajestic(context, finder) {
  return loadPathMajestic(context, finder);
}

export async function loadSlugMajestic(context, id) {
  // Talvez seja interessante tratar erros no request com try/catch em algum momento.
  const response = await requestMajestic({
    url: `/videobots/slug${id}`,
    method: "get",
  });
  window.__ovmSID = response.data.session_id;
  context.commit("setTape", response.data);

  if (response.data.is_vue) {
    const urlVue = window.location.origin + response.data.path;
    return urlVue;
  }

  return `/m${response.data.path}`;
}

export async function loadPathMajestic(context, finder) {
  // Talvez seja interessante tratar erros no request com try/catch em algum momento.
  const response = await requestMajestic({
    url: `/videobots/path`,
    method: "post",
    data: { finder },
  });
  window.__ovmSID = response.data.session_id;
  context.commit("setTape", response.data);

  if (response.data.is_vue) {
    const urlVue = window.location.origin + response.data.path;
    window.location.href = urlVue;
  }

  return `/m${response.data.path}`;
}

export async function loadFromSlug(context, slug) {
  const finder = { path: slug, source: "slug" };
  if (slug == "/9gIoBSk" || slug == "/qfqaXz8" || slug == "/NE9Rmj4")
    return loadVivo(context, finder);
  return load(context, finder);
}

export async function loadFromPath(context, finder) {
  finder.source = "path";
  return load(context, finder);
}

export async function load(context, finder) {
  // Talvez seja interessante tratar erros no request com try/catch em algum momento.
  const response = await request({
    url: `/v2/brand_channel_discovery/${finder.source}`,
    method: "post",
    data: { finder },
  });


  window.__ovmSID = response.data.tape.session_id;
  context.commit("setTape", response.data.tape);

  if (response.data.tape.is_vue) {
    const urlVue = window.location.origin + response.data.tape.path;
    return urlVue;
  }

  if (
    !response.data.tape.is_vue &&
    !v1VideoListProd.includes(response.data.tape.video_id) &&
    !v1VideoListStaging.includes(response.data.tape.video_id)
  ) {
    return `/v2${response.data.tape.path}`;
  }

  return response.data.tape.path;
}

export async function loadVivo(context, finder) {
  // Talvez seja interessante tratar erros no request com try/catch em algum momento.
  const response = await requestToVivo({
    url: `/v2/brand_channel_discovery/${finder.source}`,
    method: "post",
    data: { finder },
  });

  window.__ovmSID = response.data.tape.session_id;
  context.commit("setTape", response.data.tape);

  if (response.data.tape.is_vue) {
    const urlVue = window.location.origin + response.data.tape.path;
    window.location.href = urlVue;
  }

  if (
    !response.data.tape.is_vue &&
    !v1VideoListProd.includes(response.data.tape.video_id) &&
    !v1VideoListStaging.includes(response.data.tape.video_id)
  ) {
    return `/v2${response.data.tape.path}`;
  }

  return response.data.tape.path;
}
